var exports = {
  "k": "xcc377c0b--c2d4b1--container",
  "K": "xcc377c0b--c2d4b1--icon",
};

module.exports = exports;
